// consoles/pvc/PvcConsole.js —— 光储充控制台
// 严格依据《云平台单站控制（光储充）需求文档》组织 tab 集合：
// 站点首页 / 设备监控 / 故障告警 / 统计报表 / 控制中心（二次口令） / 系统管理
// 本类型无「主接线图」tab（仅能量流转图）、无「设备读写」、无智能策略 / 日前策略。
import React, { useState } from 'react';
import ScrollTabs from '../../../../components/ScrollTabs';
import PvcHome from '../../panels/pvc/PvcHome';
import PvcDevice from '../../panels/pvc/PvcDevice';
import PvcAlarm from '../../panels/pvc/PvcAlarm';
import PvcReport from '../../panels/pvc/PvcReport';
import PvcControl from '../../panels/pvc/PvcControl';
import PvcSystem from '../../panels/pvc/PvcSystem';

const PvcConsole = ({ station, unlocked, gate }) => {
  const [tab, setTab] = useState('home');

  const items = [
    { key: 'home', label: '站点首页', children: <PvcHome station={station} /> },
    { key: 'device', label: '设备监控', children: <PvcDevice station={station} /> },
    { key: 'alarm', label: '故障告警', children: <PvcAlarm station={station} /> },
    { key: 'report', label: '统计报表', children: <PvcReport station={station} /> },
    { key: 'control', label: '控制中心', children: unlocked ? <PvcControl station={station} /> : gate },
    { key: 'system', label: '系统管理', children: <PvcSystem station={station} /> },
  ];

  return (
    <div className="panel sm-tabs">
      <ScrollTabs activeKey={tab} onChange={setTab} items={items} />
    </div>
  );
};

export default PvcConsole;
